import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { CdsColumn } from "../CdsColumn";
import { IMultiSeriesChartData } from ".";

import { ILineChartProps, LineChart } from "./LineChart";

export interface IChartWithSummaryProps
  extends Omit<ILineChartProps, "data" | "title"> {
  isLoading: boolean;
  chartTitle: string;
  chartDataMultiSeries: IMultiSeriesChartData[];
  chartXAxisStartLabel: string;
  chartXAxisStopLabel: string;
  chartLabelClassName?: string;
  description?: string;
  total: ReactNode;
  hasSummaryData?: boolean;
  summaryRightTopTitle?: string;
  summaryRightTopUrl?: string;
  summaryRightTopText?: string;
  summaryRightTopValue?: ReactNode;
  summaryRightBottomTitle?: string;
  summaryRightBottomUrl?: string;
  summaryRightBottomText?: string;
  summaryRightBottomValue?: ReactNode;
  suffix?: ReactNode;
}

export const ChartWithSummary = ({
  isLoading,
  chartTitle,
  chartDataMultiSeries,
  chartXAxisStartLabel,
  chartXAxisStopLabel,
  chartLabelClassName,
  description,
  total,
  hasSummaryData,
  summaryRightTopTitle,
  summaryRightTopUrl,
  summaryRightTopText,
  summaryRightTopValue,
  summaryRightBottomTitle,
  summaryRightBottomUrl,
  summaryRightBottomText,
  summaryRightBottomValue,
  ...rest
}: IChartWithSummaryProps) => {
  return (
    <>
      <CdsColumn
        sm={4}
        md={hasSummaryData ? 6 : 4}
        lg={hasSummaryData ? 9 : 4}
        className="chart-with-summary--container flex-container col"
      >
        <LineChart
          isLoading={isLoading}
          data={chartDataMultiSeries ?? [{ data: [{ x: new Date(), y: 0 }] }]}
          title={chartTitle}
          total={total}
          description={description}
          stacked
          {...rest}
        />

        <div className="flex-container justify-content--between">
          <small className={`chart-label ${chartLabelClassName}`}>
            {chartXAxisStartLabel}
          </small>
          <small className={`chart-label ${chartLabelClassName}`}>
            {chartXAxisStopLabel}
          </small>
        </div>
      </CdsColumn>

      {!hasSummaryData ? (
        <></>
      ) : (
        <CdsColumn sm={4} md={2} lg={3} className="chart-summary">
          <CdsColumn>
            <h6 className="flex-container">
              <span className="flex-box font-ctm--semibold">
                {summaryRightTopTitle}
              </span>

              {summaryRightTopUrl ? (
                <Link to={summaryRightTopUrl} className="chart-link">
                  View
                </Link>
              ) : null}
            </h6>

            <p>{summaryRightTopText}</p>
            <h3 className="font-ctm--semibold">{summaryRightTopValue}</h3>
          </CdsColumn>

          <CdsColumn className="row2">
            <h6 className="flex-container">
              <span className="flex-box font-ctm--semibold">
                {summaryRightBottomTitle}
              </span>

              {summaryRightBottomUrl ? (
                <Link to={summaryRightBottomUrl} className="chart-link">
                  View
                </Link>
              ) : null}
            </h6>

            <p className="font-ctm--regular">{summaryRightBottomText}</p>
            <h3 className="font-ctm--semibold">{summaryRightBottomValue}</h3>
          </CdsColumn>
        </CdsColumn>
      )}
    </>
  );
};
